export const DAYWHEEL = 'dayWheel'
export const FULL = 'full'